import { render, staticRenderFns } from "./NewsArticlePage.vue?vue&type=template&id=482edafd&scoped=true&"
import script from "./NewsArticlePage.vue?vue&type=script&lang=js&"
export * from "./NewsArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./NewsArticlePage.vue?vue&type=style&index=0&id=482edafd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482edafd",
  null
  
)

export default component.exports